/* Epic Steals theme script. No libraries, no build step. Every feature
   here is an enhancement: without JavaScript the forms and links still
   work as normal Shopify pages. */
(() => {
  const ES = window.EpicSteals || { routes: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
  const money = (amount) =>
    new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency }).format(Number(amount));

  // ---------- Toast + cart count ----------

  let toastTimer;
  function toast(text, isError = false) {
    const el = $("#CartToast");
    if (!el) return;
    $("[data-toast-text]", el).textContent = text;
    el.classList.toggle("is-error", isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (el.hidden = true), 4500);
  }

  async function refreshCartCount() {
    try {
      const cart = await (await fetch(ES.routes.cart, { headers: { Accept: "application/json" } })).json();
      $$("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) {
      /* the count just stays as it was */
    }
  }

  async function addToCart(body) {
    const res = await fetch(ES.routes.cartAdd, {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || "Couldn't add that to your cart.");
    await refreshCartCount();
    return data;
  }

  // Quick add on product cards
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    try {
      const body = new FormData();
      body.append("id", btn.dataset.quickAdd);
      body.append("quantity", "1");
      await addToCart(body);
      toast("Added to cart. Nice snag!");
    } catch (err) {
      toast(err.message, true);
    } finally {
      btn.disabled = false;
    }
  });

  // Product page form
  $$("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      // Express checkout buttons submit on their own; only intercept ours.
      if (e.submitter && !e.submitter.matches("[data-add-button]")) return;
      e.preventDefault();
      const button = $("[data-add-button]", form);
      const error = $("[data-form-error]", form);
      if (error) error.hidden = true;
      button.disabled = true;
      try {
        await addToCart(new FormData(form));
        toast("Added to cart. Nice snag!");
      } catch (err) {
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        } else toast(err.message, true);
      } finally {
        button.disabled = false;
      }
    });
  });

  // ---------- Quantity steppers ----------

  document.addEventListener("click", (e) => {
    const minus = e.target.closest("[data-qty-minus]");
    const plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;
    const input = $("input", e.target.closest("[data-qty]"));
    const min = input.min !== "" ? Number(input.min) : 0;
    const max = input.max !== "" ? Number(input.max) : Infinity;
    const next = Math.min(max, Math.max(min, Number(input.value || 0) + (plus ? 1 : -1)));
    if (next === Number(input.value)) {
      if (plus && max !== Infinity) toast(`Only ${max} available. These go fast!`);
      return;
    }
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // ---------- Auto-submitting forms (sort, filters, cart quantities) ----------

  let submitTimer;
  document.addEventListener("change", (e) => {
    const field = e.target.closest("[data-auto-submit]");
    if (!field) return;
    const form = field.form;
    clearTimeout(submitTimer);
    submitTimer = setTimeout(() => submitClean(form), field.type === "number" ? 600 : 0);
  });

  // Drops empty fields (an untouched price box) so the URL stays tidy.
  function submitClean(form) {
    if (!form) return;
    if (form.method.toLowerCase() === "post") return form.submit();
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== "") params.append(key, value);
    });
    window.location.href = `${form.action.split("?")[0]}?${params.toString()}`;
  }
  $$("[data-filter-form]").forEach((form) =>
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      submitClean(form);
    })
  );

  // Mobile filter panel
  $$("[data-filters-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const body = document.getElementById(btn.getAttribute("aria-controls"));
      const open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      body.hidden = open;
      btn.lastElementChild.textContent = open ? "+" : "–";
    });
  });

  // ---------- Product gallery ----------

  $$("[data-gallery]").forEach((gallery) => {
    // Found by position, not a data attribute: Shopify's image_tag drops
    // attributes with an empty value, so a marker on the <img> never arrives.
    const main = $(".gallery__main img", gallery);
    if (!main) return;
    $$("[data-gallery-thumb]", gallery).forEach((thumb) => {
      thumb.addEventListener("click", () => {
        main.srcset = thumb.dataset.srcset;
        main.src = thumb.dataset.src;
        main.removeAttribute("width");
        main.removeAttribute("height");
        $$("[data-gallery-thumb]", gallery).forEach((t) => t.setAttribute("aria-current", String(t === thumb)));
      });
    });
  });

  // ---------- Variant picker ----------

  $$("[data-variant-select]").forEach((select) => {
    const form = select.closest("form");
    select.addEventListener("change", () => {
      const option = select.selectedOptions[0];
      $("[data-variant-id]", form).value = option.value;
      const price = $(".price__now", document);
      if (price) price.textContent = option.dataset.price;
      const button = $("[data-add-button]", form);
      const available = option.dataset.available === "true";
      button.disabled = !available;
      button.lastChild.textContent = available ? " Add to cart" : "Sold out";
      const url = new URL(window.location.href);
      url.searchParams.set("variant", option.value);
      history.replaceState(null, "", url);
    });
  });

  // ---------- "Just dropped": swap in the true newest ----------

  $$("[data-newest-grid]").forEach(async (grid) => {
    try {
      const html = await (await fetch(grid.dataset.src)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const items = $$("li", doc).filter((li) => li.querySelector(".card")).slice(0, Number(grid.dataset.limit) || 10);
      if (items.length > 0) grid.replaceChildren(...items);
    } catch (e) {
      /* keep the server-rendered list */
    }
  });

  // ---------- Recommendations ----------

  $$("[data-recommendations]").forEach(async (section) => {
    try {
      const html = await (await fetch(section.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const filled = $("[data-recommendations]", doc);
      if (filled && filled.innerHTML.trim()) section.innerHTML = filled.innerHTML;
      else section.remove();
    } catch (e) {
      section.remove();
    }
  });

  // ---------- Predictive search ----------

  $$("[data-predictive-search]").forEach((form) => {
    const input = $('input[type="search"]', form);
    const panel = $(".predictive", form);
    if (!input || !panel || !ES.routes.predictiveSearch) return;
    let timer;
    let controller;
    let active = -1;

    const close = () => {
      panel.hidden = true;
      input.setAttribute("aria-expanded", "false");
      active = -1;
    };

    const render = (products, term) => {
      if (products.length === 0) {
        panel.innerHTML = `<p class="predictive__empty">No steals match &ldquo;${escapeHtml(term)}&rdquo; yet.</p>`;
      } else {
        panel.innerHTML =
          `<ul class="predictive__list" role="listbox">` +
          products
            .map(
              (p, i) => `<li class="predictive__item" role="option" id="ps-${i}">
                <a href="${p.url}">
                  ${p.image ? `<img src="${p.image}${p.image.includes("?") ? "&" : "?"}width=96" alt="" width="48" height="48" loading="lazy">` : ""}
                  <span><span class="predictive__title">${escapeHtml(p.title)}</span>
                  <span class="predictive__price">${money(p.price)}</span></span>
                </a></li>`
            )
            .join("") +
          `</ul><a class="predictive__all" href="${form.action}?type=product&options[prefix]=last&q=${encodeURIComponent(term)}">See all results for &ldquo;${escapeHtml(term)}&rdquo;</a>`;
      }
      panel.hidden = false;
      input.setAttribute("aria-expanded", "true");
    };

    input.addEventListener("input", () => {
      const term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) return close();
      timer = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        try {
          const url = `${ES.routes.predictiveSearch}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor,tag`;
          const data = await (await fetch(url, { signal: controller.signal })).json();
          const products = (data.resources?.results?.products || []).map((p) => ({
            title: p.title,
            url: p.url,
            price: p.price,
            image: p.featured_image?.url || p.image || "",
          }));
          render(products, term);
        } catch (e) {
          if (e.name !== "AbortError") close();
        }
      }, 220);
    });

    input.addEventListener("keydown", (e) => {
      const links = $$(".predictive__item a", panel);
      if (panel.hidden || links.length === 0) {
        if (e.key === "Escape") close();
        return;
      }
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        active = (active + (e.key === "ArrowDown" ? 1 : -1) + links.length) % links.length;
        links.forEach((a, i) => a.setAttribute("aria-selected", String(i === active)));
        input.setAttribute("aria-activedescendant", `ps-${active}`);
      } else if (e.key === "Enter" && active >= 0) {
        e.preventDefault();
        window.location.href = links[active].href;
      } else if (e.key === "Escape") {
        close();
      }
    });

    document.addEventListener("click", (e) => {
      if (!form.contains(e.target)) close();
    });
  });

  // ---------- App mode (opened from the home screen) ----------

  if (document.documentElement.classList.contains("is-app")) {
    // An installed iPhone app has no browser back button.
    $$("[data-app-back]").forEach((btn) =>
      btn.addEventListener("click", () => {
        const cameFromStore = document.referrer && new URL(document.referrer).origin === location.origin;
        if (cameFromStore && history.length > 1) history.back();
        else location.href = ES.routes.root || "/";
      })
    );
    // The Search tab jumps to the search box (with live suggestions)
    // instead of loading an empty search page.
    $$("[data-app-search]").forEach((tab) =>
      tab.addEventListener("click", (e) => {
        const box = $("#HeaderSearch");
        if (!box) return;
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        box.focus();
      })
    );
  }

  // ---------- Deal alerts (web push) ----------
  // Through the Shopify app proxy at /apps/deals (the eBay listing tool),
  // which serves the service worker from the store's own address. Its scope
  // is /apps/deals/: it doesn't need to control pages, only receive pushes.

  (() => {
    const PUSH = "/apps/deals";
    const card = $("[data-deal-alerts]");
    const toggle = $("[data-deal-alerts-toggle]");
    const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
    const inApp = document.documentElement.classList.contains("is-app");
    if (!supported || !inApp || (!card && !toggle)) return;
    const DISMISS_KEY = "es-alerts-dismissed-until";

    const registration = () => navigator.serviceWorker.getRegistration(`${PUSH}/`);
    const currentSubscription = async () => {
      const reg = await registration();
      return reg ? reg.pushManager.getSubscription() : null;
    };
    const keyBytes = (base64url) => {
      const pad = "=".repeat((4 - (base64url.length % 4)) % 4);
      const raw = atob((base64url + pad).replace(/-/g, "+").replace(/_/g, "/"));
      return Uint8Array.from(raw, (c) => c.charCodeAt(0));
    };
    const activeWorker = (reg) =>
      reg.active
        ? Promise.resolve()
        : new Promise((resolve) => {
            const sw = reg.installing || reg.waiting;
            if (!sw) return resolve();
            sw.addEventListener("statechange", () => sw.state === "activated" && resolve());
          });

    async function turnOn() {
      // First, while the tap still counts as the shopper's own action
      // (iPhone only shows the permission prompt then).
      const permission = await Notification.requestPermission();
      if (permission !== "granted") throw new Error("blocked");
      const reg = await navigator.serviceWorker.register(`${PUSH}/sw.js`, { scope: `${PUSH}/` });
      await activeWorker(reg);
      const { publicKey } = await (await fetch(`${PUSH}/config`, { cache: "no-store" })).json();
      const sub =
        (await reg.pushManager.getSubscription()) ||
        (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: keyBytes(publicKey) }));
      const res = await fetch(`${PUSH}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subscription: sub.toJSON() }),
      });
      if (!res.ok) throw new Error("save failed");
    }

    async function turnOff() {
      const sub = await currentSubscription();
      if (!sub) return;
      await fetch(`${PUSH}/unsubscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ endpoint: sub.endpoint }),
      }).catch(() => {});
      await sub.unsubscribe();
    }

    async function refreshToggle() {
      if (!toggle) return;
      const on = Notification.permission === "granted" && Boolean(await currentSubscription());
      toggle.textContent = on ? "Deal alerts are on (turn off)" : "Turn on deal alerts";
      toggle.dataset.on = on ? "1" : "";
      toggle.hidden = Notification.permission === "denied";
    }

    const failed = (e) =>
      toast(
        e && e.message === "blocked"
          ? "Alerts are blocked for this app. Turn them on in your phone's settings."
          : "Couldn't turn on alerts. Try again in a bit.",
        true
      );

    if (toggle) {
      refreshToggle();
      toggle.addEventListener("click", async () => {
        toggle.disabled = true;
        try {
          if (toggle.dataset.on) {
            await turnOff();
            toast("Deal alerts are off.");
          } else {
            await turnOn();
            toast("Deal alerts are on!");
          }
        } catch (e) {
          failed(e);
        } finally {
          toggle.disabled = false;
          refreshToggle();
        }
      });
    }

    if (card && Notification.permission === "default") {
      try {
        if (Date.now() < Number(localStorage.getItem(DISMISS_KEY) || 0)) return;
      } catch (e) {
        /* storage blocked: just offer it */
      }
      $("[data-deal-alerts-on]", card).addEventListener("click", async () => {
        try {
          await turnOn();
          card.hidden = true;
          toast("Deal alerts are on!");
        } catch (e) {
          card.hidden = true;
          failed(e);
        }
        refreshToggle();
      });
      $("[data-deal-alerts-close]", card).addEventListener("click", () => {
        card.hidden = true;
        try {
          localStorage.setItem(DISMISS_KEY, String(Date.now() + 14 * 24 * 60 * 60 * 1000));
        } catch (e) {
          /* fine */
        }
      });
      setTimeout(() => (card.hidden = false), 6000);
    }
  })();

  // ---------- Get the app (add to home screen) ----------

  (() => {
    const card = $("[data-install-app]");
    if (!card) return;
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isPhone = isIOS || /Android/i.test(ua);
    const installed = matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
    if (!isPhone || installed) return;
    // ?app=1 is the QR code on the package insert: they scanned it to get
    // the app, so show the card right away even after an old "Not now".
    const fromQr = new URLSearchParams(location.search).has("app");
    // Instagram/Facebook/TikTok's built-in browsers can't add to the home
    // screen at all.
    const inAppBrowser = /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly/i.test(ua);
    const DISMISS_KEY = "es-install-dismissed-until";
    try {
      if (!fromQr && Date.now() < Number(localStorage.getItem(DISMISS_KEY) || 0)) return;
    } catch (e) {
      /* storage blocked: just show it */
    }

    const text = $("[data-install-text]", card);
    const go = $("[data-install-go]", card);
    let promptEvent = null;
    const show = () => (card.hidden = false);
    const hide = () => (card.hidden = true);
    if (isIOS) go.textContent = "Show me";

    // Android Chrome: the browser's own install prompt, when it offers one.
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      promptEvent = e;
      go.textContent = "Install";
      show();
    });
    window.addEventListener("appinstalled", hide);

    const showSteps = () => {
      text.textContent = inAppBrowser
        ? `Open this page in ${isIOS ? "Safari" : "Chrome"} first (tap ••• or ⋮, then “Open in browser”), then add it to your home screen.`
        : isIOS
          ? "Tap the Share button (the square with the arrow), then “Add to Home Screen”."
          : "Tap the ⋮ menu at the top, then “Add to Home screen” or “Install app”.";
      go.hidden = true;
    };

    go.addEventListener("click", async () => {
      if (!promptEvent) return showSteps();
      const event = promptEvent;
      promptEvent = null;
      try {
        // Chrome can refuse the prompt (already used, or the page stopped
        // counting as installable); the manual steps always work.
        await event.prompt();
        const choice = await event.userChoice;
        if (choice && choice.outcome === "accepted") hide();
      } catch (e) {
        showSteps();
      }
    });

    $("[data-install-close]", card).addEventListener("click", () => {
      hide();
      try {
        localStorage.setItem(DISMISS_KEY, String(Date.now() + 30 * 24 * 60 * 60 * 1000));
      } catch (e) {
        /* fine, it just shows again next visit */
      }
    });

    if (fromQr) {
      // No install prompt is coming on iPhone or in an in-app browser, so
      // the steps go straight up; Android Chrome keeps its Install button.
      if (isIOS || inAppBrowser) showSteps();
      show();
    } else {
      // A few seconds in, so it doesn't cover the first look at the store.
      setTimeout(show, 5000);
    }
  })();

  // ---------- Free local delivery ZIP check ----------
  // The shopper's ZIP is asked once and remembered on this device. The ZIP
  // list and minimum come from Theme settings > Free local delivery.

  (() => {
    const boxes = $$("[data-local-delivery]");
    if (!boxes.length) return;
    const ZIP_KEY = "es-zip";
    const read = () => {
      try {
        return localStorage.getItem(ZIP_KEY) || "";
      } catch (e) {
        return "";
      }
    };
    const save = (zip) => {
      try {
        if (zip) localStorage.setItem(ZIP_KEY, zip);
        else localStorage.removeItem(ZIP_KEY);
      } catch (e) {
        /* storage blocked: it just asks again next page */
      }
    };
    let cartTotal = null;

    async function render(box) {
      const zips = new Set((box.dataset.zips.match(/\d{5}/g) || []));
      const min = Number(box.dataset.min) / 100;
      const freeShip = Number(box.dataset.freeShip) / 100;
      const text = $("[data-ld-text]", box);
      const form = $("[data-ld-form]", box);
      const change = $("[data-ld-change]", box);
      const zip = read();
      const minText = money(min).replace(/\.00$/, "");
      box.classList.remove("is-yes", "is-no");
      if (!zip) {
        text.textContent = `Free local delivery on orders ${minText}+ in our area. Check your ZIP:`;
        form.hidden = false;
        change.hidden = true;
        return;
      }
      form.hidden = true;
      change.hidden = false;
      if (!zips.has(zip)) {
        box.classList.add("is-no");
        text.innerHTML = `Sorry, ${escapeHtml(zip)} is outside our local delivery area.` +
          (freeShip > 0 ? `<small>Free shipping on orders over ${escapeHtml(money(freeShip).replace(/\.00$/, ""))} still applies.</small>` : "");
        return;
      }
      box.classList.add("is-yes");
      if (box.dataset.context !== "cart") {
        text.innerHTML = `Free local delivery to ${escapeHtml(zip)} on orders ${escapeHtml(minText)}+`;
        return;
      }
      if (cartTotal == null) {
        try {
          cartTotal = (await (await fetch(ES.routes.cart || "/cart.js")).json()).total_price / 100;
        } catch (e) {
          cartTotal = 0;
        }
      }
      text.innerHTML =
        cartTotal >= min
          ? `This order gets free local delivery to ${escapeHtml(zip)}!<small>Pick "Local delivery" at checkout.</small>`
          : `Add <strong>${escapeHtml(money(min - cartTotal))}</strong> more for free local delivery to ${escapeHtml(zip)}.`;
    }

    const renderAll = () => boxes.forEach(render);
    boxes.forEach((box) => {
      $("[data-ld-form]", box).addEventListener("submit", (e) => {
        e.preventDefault();
        const zip = ($("[data-ld-input]", box).value.match(/\d{5}/) || [""])[0];
        if (!zip) return;
        save(zip);
        renderAll();
      });
      $("[data-ld-change]", box).addEventListener("click", () => {
        save("");
        renderAll();
        const input = $("[data-ld-input]", box);
        if (input) input.focus();
      });
    });
    renderAll();
  })();

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
  }
})();
